import { Text, Colors } from '@doordash/design-language'

import styled from 'styled-components'

export const TermsButton = styled(Text)`
  text-align: center;
  color: ${Colors.TextTertiary};
  text-decoration: underline;
`
